export default __webpack_public_path__ + "static/media/learning_1.f5966cc6.svg";